           
<div id="filterWrap" [ngStyle]=" stickySidebar.stickySidebarEnabled? {'position': stickySidebar.position, 'top': stickySidebar.top + 'px', 'width': stickySidebar.width + 'px', 'bottom': stickySidebar.bottom + 'px'}: ''" 
  class="overlay-content">
  <h2 class="mobile-hidden">Get the best offers in Chania!</h2>
  <div class="filter" id="hotelAccommodationTypes">
    <h4>Hotel type</h4>
    <div class="types">
        <mat-button-toggle *ngFor="let key of getKeys(hotelTypes)" (click) = "filterbyHotelType(key)" 
        class="type">{{hotelTypes.get(key)}}</mat-button-toggle>
    </div>
  </div>
  <div class="filter" id="hotelMealTypes">
    <h4>Meal type</h4>
    <div class="types">
      <mat-button-toggle  *ngFor="let key of getKeys(mealTypes)" (click) = "filterbyMealType(key)"
      class="type">{{mealTypes.get(key)}}</mat-button-toggle>
    </div>
  </div>
</div>
